export default __webpack_public_path__ + "static/media/rio_grande.0795a993.jpg";